import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import * as Store from '../../store';
import { store } from '../../store';

import template from './layout.vue';
import router from '../../router';

@Component({
    mixins: [template],
    store,
    router
})

export default class AdminLayout extends Vue {

     constructor() {
        super();
    }

    mounted() {

    }

    isLoggedIn() {
        return Store.readLoggedInState(this.$store);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/layout/index.ts